import { render, staticRenderFns } from "./FormTagsCustom.vue?vue&type=template&id=8f6a3b32&"
import script from "./FormTagsCustom.vue?vue&type=script&lang=js&"
export * from "./FormTagsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports